// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM17.29 10.5H12.9999V4.42862L6.70973 13.5H10.9999L10.9999 19.5714L17.29 10.5Z"}}]};

const LightingCircleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'lighting-circle-filled',
    ref,
    icon: element,
  },
));

LightingCircleFilledIcon.displayName = 'LightingCircleFilledIcon';

export default LightingCircleFilledIcon;
